import { VenueDetailLayout } from '@layouts/venue/VenueDetailLayout'
import BookingTab from '@pages/venues/detail/tabs/BookingTab'
import CustomizeTab from '@pages/venues/detail/tabs/Customize'
import GeneralTab from '@pages/venues/detail/tabs/GeneralTab'
import LegalsTab from '@pages/venues/detail/tabs/LegalsTab'
import NestedVenuesTab from '@pages/venues/detail/tabs/NestedVenuesTab'
import OverviewTab from '@pages/venues/detail/tabs/overview/OverviewTab'
import SettingsTab from '@pages/venues/detail/tabs/SettingsTab'
import WhatsappBotSettingsTab from '@pages/venues/detail/tabs/WhatsappBotSettingsTab'
import { Navigate, RouteObject } from 'react-router-dom'

const venueDetailRoutes: RouteObject[] = [
  {
    element: <VenueDetailLayout />,
    children: [
      { path: 'overview', element: <OverviewTab /> },
      { path: 'generals', element: <GeneralTab /> },
      { path: 'customize', element: <CustomizeTab /> },
      { path: 'booking', element: <BookingTab /> },
      { path: 'nested-venues', element: <NestedVenuesTab /> },
      { path: 'whatsapp-settings', element: <WhatsappBotSettingsTab /> },
      { path: 'legals', element: <LegalsTab /> },
      { path: 'settings', element: <SettingsTab /> },
      { index: true, element: <Navigate to="overview" replace /> },
      { path: '*', element: <Navigate to="overview" replace /> },
    ],
  },
]

export default venueDetailRoutes
